// config.js
const API_BASE_URL = (() => {
    const environment = process.env.REACT_APP_ENVIRONMENT;

    const apiUrls = {
        local: process.env.REACT_APP_API_URL_LOCAL,
        staging: process.env.REACT_APP_API_URL_STAGING,
        production: process.env.REACT_APP_API_URL_PRODUCTION,
    };

    return apiUrls[environment] || apiUrls.local || ""; // Default to `local` or an empty string
})();

export default API_BASE_URL;